import { Modal } from '@/components/ui/Modal'
import { PhraseForm } from './PhraseForm'
import type { PhraseValues } from './PhraseForm'
import { useCreateCustomFlashcard } from '@/hooks/useCreateCustomFlashcard'

interface AddPhraseModalProps {
  languageId: number
  initialPhrase?: string
  autoTranslate?: boolean
  onClose: () => void
  onCreated: () => void
}

export function AddPhraseModal({
  languageId, initialPhrase, autoTranslate, onClose, onCreated,
}: AddPhraseModalProps) {
  const { create, submitting, errors } = useCreateCustomFlashcard(() => {
    onCreated()
    onClose()
  })

  function handleSubmit(values: PhraseValues) {
    create({
      language_id: languageId,
      card_type: 'phrase',
      deck_id: values.deck_id,
      lemma: values.phrase,
      translation: values.translation,
      notes: values.notes || null,
    })
  }

  return (
    <Modal open onClose={onClose} title="Add phrase">
      <PhraseForm
        languageId={languageId}
        initial={{ phrase: initialPhrase ?? '', translation: '', notes: '', deck_id: null }}
        submitLabel="Add phrase"
        submitting={submitting}
        errors={errors}
        autoTranslate={autoTranslate}
        onSubmit={handleSubmit}
      />
    </Modal>
  )
}
